<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :search-btn-span="24"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <BjSelectChannelStore
          :span="colSpan"
          :query-params="queryParams"
          :query-props="['channelTypeCode', 'storeIdList']"
          :query-labels="[
            $t('ChannelManagement.Header.method'),
            $t('ChannelManagement.Header.shop'),
          ]"
          multiple
        />
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.type')" prop="onlineStoreTypeCode">
            <BjSelectLov v-model="queryParams.onlineStoreTypeCode" :placeholder="$t('ChannelManagement.Header.type')" lov-code="SCHL.SHOP_TYPE" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.Parent')" prop="orgName">
            <BjInput
              v-model="queryParams.orgName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('ChannelManagement.Header.Parent')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.status')" prop="channelWarehouseStatus">
            <BjSelectLov v-model="queryParams.channelWarehouseStatus" :option-list="STATUS_ENABLED_TRUE" />
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.Name')" prop="channelWarehouseName">
            <BjInput
              v-model="queryParams.channelWarehouseName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('ChannelManagement.Header.Name')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.Store')" prop="status">
            <BjSelectLov v-model="queryParams.status" :placeholder="$t('ChannelManagement.Header.Store')" :option-list="STATUS_ENABLED_TRUE" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:seniorForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.Authorization')" prop="authStatus">
            <BjSelectLov
              v-model="queryParams.authStatus"
              :option-list="CHANNEL_ONLINE_CREDIT_STATUS"
              :placeholder="$t('ChannelManagement.Header.Authorization')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.taxCode')" prop="taxCode">
            <BjInput
              v-model="queryParams.taxCode"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('ChannelManagement.Header.taxCode')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.accountCode')" prop="accountCode">
            <BjInput
              v-model="queryParams.accountCode"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('ChannelManagement.Header.accountCode')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.currency')" prop="currency">
            <BjSelectLov v-model="queryParams.currency" :placeholder="$t('ChannelManagement.Header.currency')" :option-list="CURRENCY_LIST" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item
            :label="$t('ChannelManagement.Header.typeOfFreight')"
            prop="autoTableStatus"
          >
            <BjSelectLov
              v-model="queryParams.autoTableStatus"
              lov-code="FREIGHT_TYPE"
              :placeholder="$t('ChannelManagement.Header.typeOfFreight')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item
            :label="$t('ChannelManagement.Header.shippingCostAutoStatus')"
            prop="shippingCostAutoStatus"
          >
            <BjSelectLov
              v-model="queryParams.shippingCostAutoStatus"
              :option-list="STATUS_YES_NUM"
              :placeholder="$t('ChannelManagement.Header.shippingCostAutoStatus')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.project')" prop="project">
            <BjInput v-model="queryParams.project" :placeholder="$t('ChannelManagement.Header.project')" clearable />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            v-permission:BusinessChannelOnlineList_Delete
            type="primary"
            :disabled="tableOperationProp.notSelected"
            class="delete-btn"
            @click="onDeleteSelected"
            >{{ $t('delText') }}</el-button
          >
          <el-button
            v-permission:BusinessChannelOnlineList_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('ChannelManagement.Header.New') }}</el-button
          >
          <!-- <el-button
            v-permission:BusinessChannelOnlineList_Auth
            :disabled="tableOperationProp.notSingle"
            @click="handleCommand(0)"
            >{{ $t('ChannelManagement.Header.empower') }}</el-button
          > -->
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <!-- 授权状态 -->
              <template v-else-if="col.prop === 'authStatus'">
                <el-tag :type="scope.row.authStatus === 2 ? 'success' : 'info'"
                  >{{ $t(CHANNEL_ONLINE_CREDIT_STATUS.bjGet(scope.row.authStatus)) }}
                </el-tag>
              </template>

              <el-tag
                v-else-if="col.prop === 'status'"
                :type="scope.row.status ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row.status)) }}</el-tag
              >

              <el-tag
                v-else-if="col.prop === 'autoTableStatus'"
                :type="scope.row.autoTableStatus ? 'success' : 'info'"
                >{{ $t(STATUS_YES_TRUE.bjGet(scope.row.autoTableStatus)) }}</el-tag
              >
              <el-tag
                v-else-if="col.prop === 'shippingCostAutoStatus'"
                :type="scope.row.shippingCostAutoStatus ? 'success' : 'info'"
                >{{ $t(STATUS_YES_TRUE.bjGet(scope.row.shippingCostAutoStatus)) }}</el-tag
              >
              <el-tag
                v-else-if="col.prop === 'channelWarehouseStatus'"
                :type="scope.row.channelWarehouseStatus ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row.channelWarehouseStatus)) }}</el-tag
              >
              <template
                v-else-if="
                  ['autoDownloadGoods', 'autoPullOrder', 'autoSyncInventory'].includes(col.prop)
                "
              >
                <i :class="scope.row[col.prop] ? 'el-icon-check' : ''"></i>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button v-permission:BusinessChannelOnlineList_Edit type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
              <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="distribution">{{ $t('ChannelManagement.Main.distribution') }} </el-dropdown-item>
                  <el-dropdown-item v-if="props.row.status" v-permission:BusinessChannelOnlineList_Status command="stop"> {{ $t('disableText') }} </el-dropdown-item>
                  <el-dropdown-item v-if="!props.row.status" v-permission:BusinessChannelOnlineList_Status command="start"> {{ $t('enableText') }} </el-dropdown-item>
                  <el-dropdown-item v-permission:BusinessChannelOnlineList_Delete command="delete" :disabled="props.row.status"> {{ $t('delText') }} </el-dropdown-item>
                  <el-dropdown-item command="inquiry"> {{ $t('ChannelManagement.Main.productPrice') }} </el-dropdown-item>
                </el-dropdown-menu>
          </el-dropdown>
              <!-- <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('ChannelManagement.Main.distribution') }}</el-button>
              <el-button v-if="props.row.status" v-permission:BusinessChannelOnlineList_Status type="text" @click="onStatus(false, props.row)">{{ $t('disableText') }}</el-button>
              <el-button v-if="!props.row.status" v-permission:BusinessChannelOnlineList_Status type="text" @click="onStatus(true, props.row)">{{ $t('enableText') }}</el-button>
              <el-button v-permission:BusinessChannelOnlineList_Delete :disabled="props.row.status" type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button> -->
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />

    <!-- 授权弹窗 -->
    <AuthorizeForm ref="AuthorizeForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />

    <!-- 网店设置 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="setDialogVisible"
      :before-close="handleClose"
      width="500px"
      append-to-body
    >
      <el-form
        ref="setForm"
        :inline="false"
        :model="setForm"
        :rules="setRules"
        label-width="140px"
        class="bj-label-colon"
      >
        <el-form-item :label="$t('ChannelManagement.Main.name')" prop="name">
          <BjInput
            v-model="setForm.name"
            :maxlength="MAX_LENGTH.DEFAULT"
            disabled
            :placeholder="$t('inputText')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('ChannelManagement.Main.shipment')" prop="autoConfirmDay">
          <BjInputNumber v-model="setForm.autoConfirmDay" not-auto-zero>
            <template #append> {{ $t('ChannelManagement.Main.Day') }} </template>
          </BjInputNumber>
        </el-form-item>
        <el-form-item :label="$t('ChannelManagement.Main.products')">
          <el-switch v-model="setForm.autoDownloadGoods" />
        </el-form-item>
        <el-form-item :label="$t('ChannelManagement.Main.inventory')">
          <el-switch v-model="setForm.autoSyncInventory" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleSetConfirm">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { channelApi, baseDataApi } from '@/api';
import {
  STATUS_ENABLED_TRUE,
  CHANNEL_ONLINE_CREDIT_STATUS,
  STATUS_YES_NUM,
  STATUS_YES_TRUE,
} from '@/utils/constants';
import DataForm from './components/DataForm.vue';
import AuthorizeForm from './components/AuthorizeForm.vue';
import { VUE_APP_BASE_API } from '@/utils';

// 币种CODE
const LOVCODE = 'CHANNEL_CURRENCY';
export default {
  name: 'BusinessChannelOnline',
  components: {
    DataForm,
    AuthorizeForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      STATUS_YES_TRUE,
      STATUS_YES_NUM,
      STATUS_ENABLED_TRUE,
      CHANNEL_ONLINE_CREDIT_STATUS,
      queryApi: channelApi.getOnlineShopPage,
      // 查询参数
      queryParams: {
        name: null,
        channelTypeCode: null,
        storeIdList: [],
        channelWarehouseName: null,
        onlineStoreTypeCode: null,
        channelWarehouseStatus: null,
        status: null,
        orgName: null,
        // 授权状态
        authStatus: null,
        taxCode: null,
        accountCode: null,
        currency: null,
        autoTableStatus: null,
        shippingCostAutoStatus: null,
        project: null,
      },
      CURRENCY_LIST: [],
      title: this.$t('ChannelManagement.Main.she'),
      setDialogVisible: false,

      /** 表单-设置 */
      setForm: {
        name: null,
        autoConfirmDay: 0,
        autoDownloadGoods: false,
        autoSyncInventory: false,
        id: null,
        objectVersionNumber: null,
      },
      setRules: {
        autoConfirmDay: [
          { required: true, message: this.$t('ChannelManagement.Main.ps'), trigger: 'blur' },
        ],
        autoDownloadGoods: [
          { required: true, message: this.$t('ChannelManagement.Main.ps1'), trigger: 'change' },
        ],
        autoSyncInventory: [
          { required: true, message: this.$t('ChannelManagement.Main.ps1'), trigger: 'change' },
        ],
        name: [{ required: true, message: this.$t('ChannelManagement.Main.ps2'), trigger: 'blur' }],
      },
      labelsVersion: 16,
      labelList: [
        { label: 'ChannelManagement.Main.code', prop: 'code', isCheck: true, disabled: false, width: 135 },
        { label: 'ChannelManagement.Main.name', prop: 'name', isCheck: true, disabled: false, width: 140 },
        { label: 'ChannelManagement.Main.channel', prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: 135},
        { label: 'ChannelManagement.Main.Parent', prop: 'orgName', isCheck: true, disabled: false, width: 135 },
        { label: 'ChannelManagement.Header.taxCode', prop: 'taxCode', isCheck: true, disabled: false, width: 150 },
        { label: 'ChannelManagement.Header.accountCode', prop: 'accountCode', isCheck: true, disabled: false, width: 150 },
        { label: 'ChannelManagement.Header.currency', prop: 'currency', isCheck: true, disabled: false, width: 150 },
        { label: 'ChannelManagement.Header.project', prop: 'project', isCheck: true, disabled: false, width: 150 },
        { label: 'ChannelManagement.Main.status', prop: 'authStatus', isCheck: true, disabled: false, width: 150 },
        { label: 'ChannelManagement.Main.time', prop: 'authTime', isCheck: true, disabled: false, width: 140 },
        { label: 'ChannelManagement.Main.expiration', prop: 'authEndTime', isCheck: true, disabled: false, width: 180 },
        { label: 'ChannelManagement.Main.store', prop: 'onlineStoreTypeMeaning', isCheck: true, disabled: false, width: 140},
        { label: 'ChannelManagement.Main.Nam', prop: 'channelWarehouseName', isCheck: true, disabled: false, width: 185},
        { label: 'ChannelManagement.Header.autoTableStatus', prop: 'autoTableStatus', isCheck: true, disabled: false, width: 185 },
        { label: 'ChannelManagement.Header.shippingCostAutoStatus', prop: 'shippingCostAutoStatus', isCheck: true, disabled: false, width: 185 },
        { label: 'ChannelManagement.Main.statu', prop: 'channelWarehouseStatus', isCheck: true, disabled: false, width: 185},
        { label: 'ChannelManagement.Main.sta', prop: 'status', isCheck: true, disabled: false, width: 130 },
        { label: 'ChannelManagement.Main.Creator', prop: 'createdName', isCheck: true, disabled: false, width: 130 },
        { label: 'ChannelManagement.Main.Creation', prop: 'creationDate', isCheck: true, disabled: false, width: 180 },
        { label: 'ChannelManagement.Main.Associated', prop: 'relationPhysicalShopName', isCheck: true, disabled: false, width: 135},
        { label: 'ChannelManagement.Main.products', prop: 'autoDownloadGoods', isCheck: true, disabled: false, width: 180},
        { label: 'ChannelManagement.Main.orders', prop: 'autoPullOrder', isCheck: true, disabled: false, width: 180},
        { label: 'ChannelManagement.Main.inventory', prop: 'autoSyncInventory', isCheck: true, disabled: false, width: 144 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 135 },
      ],
      selectedRow: null,
    };
  },
  watch: {},
  mounted() {
    setTimeout(()=>{
      this.getLovCode();
    },2000)
  },
  methods: {
    command(text, row) {
      switch (text) {
        case 'distribution':
          this.onView(row);
          break;
        case 'stop':
          this.onStatus(false, row);
          break;
        case 'start':
          this.onStatus(true, row);
          break;
        case 'delete':
          this.onDelete(row);
          break;
        case 'inquiry':
          this.onProductInquiry(row);
          break;
      }
    },
    // 获取币种值集
    async getCurrencyList(id) {
      // 币种ID
      const res = await baseDataApi.getLovValuesByLovId({ lovId: id });
      this.CURRENCY_LIST = res.content.map(item => {
        return {
          label: item.meaning,
          value: item.meaning,
        };
      });
    },
    getLovCode() {
      baseDataApi.getLovHeadersByLovCode({ lovCode: LOVCODE }).then(res => {
        if (res.lovId) {
          this.getCurrencyList(res.lovId);
        }
      });
    },
    handleSetConfirm() {
      const API_DATA = this.$lodash.clone(this.setForm);
      delete API_DATA.name;
      this.$refs['setForm'].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.setApi(API_DATA);
      });
    },
    handleClick() {
      this.authorizeFun(this.selectedRows[0].channelTypeCode);
    },
    handleCommand(command) {
      /** 如果是授权 */
      if (command === 0) {
        if (this.selectedRows[0].authStatus === 2) {
          this.msgError(this.$t('ChannelManagement.Main.ps3'));
          return;
        }
        this.authorizeFun(this.selectedRows[0].channelTypeCode);
      }
      /** 停用授权 */
      if (command === 1) {
        this.$message(this.$t('ChannelManagement.Main.ps4'));
      }
      /** 恢复授权 */
      if (command === 2) {
        this.$message(this.$t('ChannelManagement.Main.ps5'));
      }
    },
    /** 授权函数 */
    authorizeFun(type) {
      /** 拼多多授权 */
      const state = type + '_' + this.selectedRows[0].code;
      window.open(VUE_APP_BASE_API() + '/third-adapter/authorize?state=' + state);
    },
    /** 新增网店 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 分配物流 */
    onView(row) {
      this.$toPage('BusinessChannelOnlineFlowDistribution', { shopCode: row.code, shopId: row.id });
    },
    /** 商品询价 */
    onProductInquiry(row) {
      this.$store.commit('business/setStorePriceControl', row);
      this.$toPage('BusinessChannelOnlinePriceManagement');
    },
    /** 编辑操作 */
    onEdit(row) {
      channelApi.getOnlineShopDetails({ id: row.id }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          res.objectVersionNumber = row.objectVersionNumber;
          this.$refs.DataForm.show(this.$lodash.clone(res));
        }
      });
    },
    /** 设置 */
    onSet(row) {
      this.selectedRow = this.$lodash.clone(row);
      this.setForm.id = this.selectedRow.id;
      this.setForm.objectVersionNumber = this.selectedRow.objectVersionNumber;
      this.setForm.name = this.selectedRow.name;
      this.setDialogVisible = true;
      channelApi.getOnlineShopSetting({ id: row.id }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.setForm = {
            ...res,
          };
        }
      });
    },
    /** 禁用 */
    onStatus(flag, row) {
      this.$confirm(this.$t('ChannelManagement.Main.ps6'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('okText'),
        cancelButtonText: this.$t('cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: row.id,
            objectVersionNumber: row.objectVersionNumber,
            flag: flag,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(this.$t('ChannelManagement.Main.ps7'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('okText'),
        cancelButtonText: this.$t('cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.deleteApi({
            id: row.id,
            objectVersionNumber: row.objectVersionNumber,
          });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => e.channelWarehouseStatus == true)) {
        this.$message.warning(this.$t('ChannelManagement.Main.ps8'));
        return;
      }

      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('ChannelManagement.Main.ps7'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('okText'),
        cancelButtonText: this.$t('cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    /* 关闭弹窗 */
    handleClose() {
      this.setDialogVisible = false;
    },
    setApi(API_DATA) {
      channelApi.setOnlineShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('ChannelManagement.Main.ps9'));
          setTimeout(() => {
            this.handleClose();
            this.reFresh();
          }, 500);
        }
      });
    },

    operationApi(API_DATA) {
      channelApi.operationOnlineShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('ChannelManagement.Main.ps91'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    deleteApi(API_DATA) {
      channelApi.deleteOnlineShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('ChannelManagement.Main.ps91'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      channelApi.batchDeleteOnlineShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('ChannelManagement.Main.ps91'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
